module.exports = __webpack_public_path__ + "img/exhibit.f68a8560.png";